export const landingPage = {
  hero: {
    badge: "Bespire Creator Platform",
    title: "Építsd fel a creator birodalmadat AI-vezérelt eszközökkel",
    description: "A Bespire mindent megad a creatoroknak, amire szükségük van egy sikeres online vállalkozás felépítéséhez. Készíts digitális tartalmat, kínálj szolgáltatásokat és lépj kapcsolatba a közönségeddel - mind egy helyen.",
    buttons: {
      getStarted: "Kezdj ingyen",
      watchDemo: "Nézd meg a demót"
    }
  },
  features: {
    title: "Minden, amire szükséged van",
    description: "Platformunk hatékony eszközöket kínál, hogy szenvedélyedet profittá alakítsd több bevételi forrással.",
    items: {
      dashboard: {
        title: "Átfogó irányítópult",
        description: "Kövesd nyomon az összes értékesítést, előfizetést és interakciót egy áttekinthető dashboardon."
      },
      digitalContent: {
        title: "Digitális tartalmak",
        description: "Készítsd el és értékesítsd digitális tartalmaidat, például e-könyveket, útmutatókat, képeket és videókat."
      },
      consultations: {
        title: "Konzultációk",
        description: "Szervezz online vagy személyes, egyéni vagy csoportos találkozót közönségeddel."
      },
      messaging: {
        title: "Üzenetváltás",
        description: "Profitálj szakértelmeddel, személyre szabott tanácsadással és közvetlen beszélgetésekkel."
      },
      personalVideo: {
        title: "Személyes videóüzenetek",
        description: "Kínálj egyedi videós köszöntőket és személyre szabott tartalmat különleges alkalmakra."
      },
      analytics: {
        title: "Részletes analitika",
        description: "Értsd meg közönséged és tedd hatékonyabbá az üzletedet pontos adatokkal."
      },
      aiChat: {
        title: "AI asszisztens",
        description: "Készítsd el saját weboldaladat gyorsan és hatékonyan az AI asszisztensünk segítségével, amely végigvezet minden lépésen."
      },
      customization: {
        title: "Testreszabás",
        description: "Alakítsd a profilod a márkád igényei szerint színekben, elrendezésben és funkciókban."
      }
    }
  },
  dashboard: {
    title: "Minden egy helyen, áttekinthetően",
    description: "Az intuitív dashboard segít nyomon követni a rendeléseket, a bevételt és az ügyfelekkel való interakciókat.",
    welcome: "Üdvözlünk, Creator!",
    stats: {
      newOrders: "Új rendeléseid",
      lastOrder: "Utolsó rendelés: 2 órája",
      activeBookings: "Aktív foglalásaid",
      upcoming: "3 a következő 24 órában",
      unreadMessages: "Olvasatlan üzenetek",
      newSubscribers: "2 új feliratkozó ma",
      revenue: "Havi bevétel",
      growth: "+32% az előző hónaphoz képest"
    },
    activity: {
      title: "Teendőid",
      viewAll: "Összes megtekintése",
      task1: "Töltsd fel profilképed és a borítóképet",
      task1Status: "Segít növelni a konverziós rátát",
      task2: "Hozz létre első digitális terméket",
      task2Status: "Passzív bevételi forrás",
      task3: "Állítsd be a konzultációs időpontjaidat",
      task3Status: "Segít az ügyfeleknek időpontot foglalni"
    },
    purchases: {
      title: "Legutóbbi vásárlások",
      viewAll: "Összes megtekintése",
      customer1: "Nagy Zsófia",
      product1: "Edzésterv csomag",
      amount1: "18 900 Ft",
      date1: "Ma, 13:45",
      customer2: "Kovács Péter",
      product2: "Egyéni konzultáció",
      amount2: "24 000 Ft",
      date2: "Tegnap, 09:32",
      customer3: "Tóth Anna",
      product3: "Személyes videóüzenet",
      amount3: "12 000 Ft",
      date3: "2 napja"
    }
  },
  aiBuilder: {
    badge: "AI-vezérelt weboldalépítő",
    title: "Tervezd meg tökéletes creator oldaladat AI segítségével",
    description: "AI asszisztensünk végigvezet az egyedi creator oldalad létrehozásán egy egyszerű beszélgetés során. Nincs szükség technikai ismeretekre - egyszerűen írd le, mit szeretnél, és nézd, ahogy a professzionális weboldalad alakot ölt a szemed előtt.",
    features: [
      "Nincs szükség kódolásra - csak beszélgess AI asszisztensünkkel",
      "Személyre szabott oldaltervezés a márkád alapján",
      "Tartalom szervezési javaslatok",
      "Okos árazási javaslatok piaci adatok alapján",
      "Automatikus mobiloptimalizálás",
      "SEO fejlesztések a jobb láthatóságért"
    ],
    chat: {
      aiWelcome: "Szia! Én vagyok az AI asszisztensed. Segítek felépíteni a creator oldaladat. Mesélj magadról és arról, milyen oldalt szeretnél létrehozni.",
      userExample: "Fitnesz edző vagyok és szeretnék egy oldalt, ahol edzésprogramokat értékesíthetek és online konzultációkat kínálhatok.",
      aiResponse: "Nagyszerű! Készítsünk neked egy fitnesz edző oldalt. Milyen stílust preferálnál: modern és energikus, vagy letisztult és professzionális?",
      inputPlaceholder: "Írd be üzeneted..."
    }
  },
  testimonials: {
    title: "Creatorok kedvence",
    description: "Csatlakozz ezrekhez, akik platformunkkal fejlesztik vállalkozásukat.",
    items: [
      {
        content: "A Bespire teljesen átalakította a creator vállalkozásomat. Az AI építő segítségével hihetetlen egyszerű volt beállítani az oldalamat, és a többféle bevételi forrás 70%-kal növelte a bevételemet.",
        author: "Kovács Réka",
        role: "Fitnesz Creator"
      },
      {
        content: "Kezdetben szkeptikus voltam, de a Bespire valóban beváltotta az ígéreteit. Az analitikai irányítópult segít megérteni, hogy melyik tartalom értékesíthető a legjobban, és a konzultációs foglalási rendszer zökkenőmentes.",
        author: "Nagy Tamás",
        role: "Pénzügyi coach"
      },
      {
        content: "A személyes videóüzenetek funkció vált a legnagyobb bevételi forrásommá. A rajongók imádják a személyes kapcsolatot, én pedig azt, hogy a Bespire milyen egyszerűvé teszi a rendelések kezelését.",
        author: "Szabó Eszter",
        role: "Tartalomkészítő"
      }
    ]
  },
  pricing: {
    title: "Egyszerű és átlátható árazás",
    description: "Nincsenek havi díjak vagy rejtett költségek. Csak akkor fizetsz, ha keresel.",
    free: {
      title: "Ingyenes csomag",
      description: "Tökéletes az induláshoz",
      price: "0 Ft",
      period: "/hónap",
      button: "Kezdj ingyen",
      includedTitle: "Mit tartalmaz:",
      features: [
        "Alap creator profil",
        "Digitális tartalom értékesítés (10% jutalék)",
        "Alap analitika",
        "Email támogatás"
      ]
    },
    pro: {
      title: "Pro csomag",
      description: "Komoly creatoroknak",
      price: "5%",
      period: "csak jutalék",
      button: "Váltás Pro-ra",
      includedTitle: "Minden, ami az Ingyenesben, plusz:",
      features: [
        "Egyedi domain név",
        "Alacsonyabb 5% jutalék",
        "Elsőbbségi fizetésfeldolgozás",
        "Fejlett analitika",
        "Elsőbbségi támogatás",
        "Egyedi márkabeállítások"
      ],
      badge: "NÉPSZERŰ"
    }
  },
  faq: {
    title: "Gyakran Ismételt Kérdések",
    description: "További kérdéseid vannak? Lépj kapcsolatba ügyfélszolgálatunkkal.",
    items: [
      {
        question: "Hogyan működik az AI weboldalépítő?",
        answer: "AI weboldalépítőnk egy rövid onboardinggal kezdődik, ahol a creator megadja az alapvető információkat. Ezután az AI célzott kérdéseket tesz fel, hogy teljesen testre tudja szabni az oldalt a creator igényei szerint. Az oldal létrehozása után a creator folyamatosan használhatja az AI asszisztenst az oldal szerkesztésére és karbantartására, így bármilyen változtatást könnyedén elvégezhet technikai tudás nélkül is."
      },
      {
        question: "Milyen típusú digitális tartalmakat értékesíthetek?",
        answer: "Gyakorlatilag bármilyen digitális tartalmat értékesíthetsz, beleértve e-könyveket, oktató videókat, online kurzusokat, edzésterveket, étrendeket, sablonokat, művészeti alkotásokat, zenét és sok mást. Platformunk különféle fájlformátumokat támogat, hogy alkalmazkodjon a különböző tartalomtípusokhoz."
      },
      {
        question: "Hogyan működnek a kifizetések?",
        answer: "Mi kezeljük neked az összes fizetési feldolgozást. Amikor valaki megvásárolja a tartalmadat vagy szolgáltatásodat, a fizetés biztonságosan feldolgozásra kerül, és a jutalékunk levonása után megkapod az összeget a fiókodban. Ezt bármikor kiveheted a bankszámládra."
      },
      {
        question: "Kínálhatok előfizetéses tartalmakat?",
        answer: "Igen, létrehozhatsz előfizetéses ajánlatokat, ahol a rajongók rendszeres díjat fizetnek exkluzív tartalmakért, frissítésekért vagy folyamatos szolgáltatásokért. Ez segít egy stabil, kiszámítható bevételi forrást kiépíteni."
      },
      {
        question: "Hogyan ütemezek konzultációkat az ügyfelekkel?",
        answer: "Platformunk integrált ütemezőrendszert tartalmaz. Beállítod az elérhetőségedet, és az ügyfelek közvetlenül foglalhatnak időpontokat az oldaladon keresztül. Értesítéseket kapsz az új foglalásokról, és az ügyfelek automatikus emlékeztetőket kapnak az alkalom előtt."
      }
    ]
  },
  newsletter: {
    title: "Értesülj elsőként az indulásunkról",
    description: "Iratkozz fel hírlevelünkre, hogy korai hozzáférést kapj!",
    placeholder: "Add meg az email címed",
    button: "Feliratkozás",
    success: {
      title: "Köszönjük a feliratkozást!",
      description: "Értesíteni fogunk az indulásunkról és értékes creator erőforrásokat küldünk."
    },
    privacy: "Tiszteletben tartjuk a magánéletedet. Bármikor leiratkozhatsz."
  },
  footer: {
    description: "A mindent-egyben platform creatoroknak az online jelenlétük kiépítéséhez, növeléséhez és monetizálásához AI-vezérelt eszközökkel.",
    categories: {
      platform: "Platform",
      support: "Támogatás",
      legal: "Jogi"
    },
    platformLinks: [
      "Funkciók",
      "Árazás",
      "AI Builder",
      "Vélemények"
    ],
    supportLinks: [
      "Súgóközpont",
      "Creator útmutatók",
      "Kapcsolat",
      "GYIK"
    ],
    legalLinks: [
      "Adatvédelmi irányelvek",
      "Felhasználási feltételek",
      "Cookie szabályzat",
      "Elfogadható használat"
    ],
    copyright: "© {year} Bespire. Minden jog fenntartva.",
    bottomLinks: [
      "Adatvédelem",
      "Feltételek",
      "Cookie-k"
    ]
  },
  communitySupport: {
    badge: "Közösségi támogatás",
    title: "Sosem leszel egyedül az utadon",
    description: "A Bespire platformon nemcsak eszközöket kapsz, hanem egy támogató közösséget és szakértői segítséget is, hogy sikeres alkotói lehess",
    features: [
      {
        title: "Alkotói közösség",
        description: "Csatlakozz más sikeres alkotóihoz, ossz meg ötleteket és építs értékes kapcsolatokat"
      },
      {
        title: "Kreatív inspiráció",
        description: "Fedezz fel sikeres stratégiákat és új ötleteket más alkotóik példái alapján"
      },
      {
        title: "24/7 támogatás",
        description: "Bármikor kérhetsz segítséget dedikált támogatói csapatunktól, akik mindenben segítenek"
      },
      {
        title: "Részletes tudásbázis",
        description: "Oktató anyagok, útmutatók és példák segítenek a platformunk maximális kihasználásában"
      }
    ],
    quote: "A sikeres alkotóik soha nem dolgoznak teljesen egyedül. A közösség ereje és a megfelelő támogatás az, ami megkülönbözteti őket.",
    joinText: "Csatlakozz több mint 10 000 alkotóihoz"
  },
  contentTools: {
    badge: "Tartalomkészítő eszközök",
    title: "A tartalom létrehozása még soha nem volt ilyen egyszerű",
    description: "Hatékony eszközeink segítségével percek alatt létrehozhatsz professzionális minőségű digitális tartalmakat",
    tools: [
      {
        title: "Digitális tartalmak egyszerűen",
        description: "Hozz létre minőségi digitális termékeket drag-and-drop szerkesztőnkkel, speciális technikai tudás nélkül"
      },
      {
        title: "Egy-kattintásos publikálás",
        description: "Mentsd el és tedd közzé tartalmaidat azonnal, bonyolult folyamatok nélkül"
      },
      {
        title: "Gyors tartalom frissítés",
        description: "Frissítsd tartalmaidat bármikor, a változtatások azonnal élnek, és a vásárlók automatikusan értesülnek"
      },
      {
        title: "Értékelések és visszajelzések",
        description: "Gyűjts értékeléseket és visszajelzéseket a vásárlóktól, hogy folyamatosan fejleszthesd tartalmaidat"
      }
    ]
  },
  creatorSecurity: {
    badge: "Megbízhatóság és biztonság",
    title: "Védjük a te és ügyfeleid adatait",
    description: "Platformunk fejlett biztonsági intézkedésekkel védi minden adatod és bevételed, hogy te csak a tartalomkészítésre koncentrálhass",
    features: [
      {
        title: "Biztonságos fizetési feldolgozás",
        description: "Minden tranzakciót biztonságos fizetési kapukon keresztül dolgozunk fel, megfelelve a legszigorúbb iparági szabványoknak."
      },
      {
        title: "Tartalomvédelem",
        description: "A digitális termékedet DRM védelemmel látjuk el, hogy megakadályozzuk az illetéktelen hozzáférést és megosztást."
      },
      {
        title: "Adatvédelem",
        description: "GDPR-kompatibilis rendszerünk biztosítja, hogy a személyes adatok mindig a jogszabályoknak megfelelően legyenek kezelve."
      },
      {
        title: "Átlátható jutalékrendszer",
        description: "Nincsenek rejtett költségek vagy váratlan levonások - mindig pontosan tudod, mennyit keresel és mikor kapod meg."
      }
    ],
    security: {
      payment: "Biztonságos fizetés",
      privacy: "Adatvédelem",
      encryption: "SSL titkosítás"
    }
  }
};
